import {
  AfterViewInit,
  ChangeDetectorRef,
  Component, ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output, ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {
  ActivityDataItem,
  ActivityDataRealTimeUpdateInfo,
  ActivityFeedInfo,
  ActivityFeedType, ActivityFeedTypesDictionary,
  ActivityFilterModel,
  ConversationsByFilter,
  DefaultActivityFeedByTool,
  DefaultActivityFilterSettings,
  ReferenceNotificationPreferenceType, ReferenceNotificationSettings
} from '../../../store/activity.model';
import {BehaviorSubject, combineLatest, Observable, Subject} from 'rxjs';
import {ContactState, getAllContacts, getLastSeenDictionary} from '../../../../../contacts/store/contact.reducer';
import {ChatEditorOutput} from '@shared/models/chat-editor.model';
import {select, Store} from '@ngrx/store';
import {skip, take, takeUntil} from 'rxjs/operators';
import {
  ActivityFilterDateRangeTypes,
  ActivityFilterSettings,
  ActivityTrackerHeaderMenuTypes
} from '@shared/models/activity-tracker-header.model';
import {Guid} from 'guid-typescript';
import {CollaborationQuery} from '../../../store/collaboration.query';
import {GraphQLService} from '@core/services/graphql.service';
import {CollaborationConfig} from '../../../store/collaboration.config';
import {GraphqlContentScope} from '@shared/models/graphql-content-scope.model';
import {ContentScope, PlatformCommand} from '@shared/commands/command-base';
import {CommandService} from '@core/services/command.service';
import {GetAllSharedContactsAction} from '../../../../../contacts/store/contact.action';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {NavigationState} from '../../../../../navigation/store/navigation.reducers';
import {getCurrentMenuItem} from '../../../../../navigation/store/navigation.selectors';
import {SnackBarService} from '@core/services/snack-bar.service';
import {ActivityFilterService} from '../../../services/activity-filter.service';
import {DialogModel} from '@shared/models/dialog.model';
import {DialogService} from '@shared/services/dialog-service';
import {TimeZoneService} from '@core/services/time-zone.service';
import {ActivityDateRangeTypeScope} from '../../../store/activity-date-range-type-scope.model';
import {SecurityState} from '@shared/store/reducers/security.reducer';
import {getUserInfo, hasFeature} from '@shared/store/selectors/security.selector';
import {UserInfo} from '@shared/models/user-info.model';
import {getAllCountries, getCurrentPlatformLink, ParticleState} from '@shared/store/reducers/particle.reduer';
import {MagicLinkModel} from '@shared/models/platform-tool-models';
import {CollaborationState} from '../../../store/collaboration.reducer';
import {getcurrentEditorId, getOthersTrackBatchActivity} from '../../../store/collaboration.selector';
import {Conversation} from '../../../store/collaboration.models';
import {CreateChatConversationAction, SetCurrentTextEditorId} from '../../../store/collaboration.action';
import  moment_ from 'moment';
import {QueryProvider} from '@shared/queries/query-provider';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {ToolInfo} from '@shared/models/solution-tree.model';
import {PlatformSidebarState} from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import {PlatformSidebarService} from '@shared/components/platform-sidebar/store/platform-sidebar.service';
import {
  auditTrailMappingByToolId
} from '@features/task-manager/collaboration/components/ActivityTracker/activity.constants';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {Api} from '@shared/constants/common-field.constants';
import {Contact} from '@features/contacts/store/contact.model';
import {CreateChatConversationCommand} from '@features/task-manager/collaboration/store/collaboration.command';
import {ConversationComponentName} from '@features/task-manager/collaboration/store/collaboration.constants';
import {UserModel} from '@shared/models/user.model';
import {SetActivityFeedAction} from "@shared/components/platform-sidebar/store/platform-sidebar.action";
import {MatExpansionPanel} from "@angular/material/expansion";
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {FlexSheetService} from '@features/spreadsheet/services/flex-sheet.service';
import {BasketProvider} from '@shared/models/basket-provider';
import {ExcelHelper} from '@features/spreadsheet/helpers/excel-helper';
import {Router} from '@angular/router';
import {CountryModel} from '@shared/models/country.model';

@Component({
    standalone: false,
    selector: 'particle-activity-feed',
  templateUrl: './activity-feed.component.html',
  styleUrls: ['./activity-feed.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ActivityFeedComponent implements OnInit, OnDestroy, AfterViewInit {

  private _feedInfo: ActivityFeedInfo = null;
  public get feedInfo(): ActivityFeedInfo {
    return this._feedInfo;
  }
  @Input() public set feedInfo(value: ActivityFeedInfo) {
    this._feedInfo = value;
    this.activityFeedInfoEvent$.emit({
      type: 'ActivityFeedInfoChanged',
      data: this._feedInfo
    });
  }
  private _showChatEditor = false;
  public get showChatEditor(): boolean {
    return this._showChatEditor;
  }
  @Input() public set showChatEditor(value: boolean) {
    if (value !== this._showChatEditor) {
      this._showChatEditor = value;
      this.activityFeedInfoEvent$.emit({
        type: 'ChatEditorStateChanged',
        chatEditorOpened: value
      });
    }
  }
  @Input() isExpanded = false;
  @Input() setFeedOnRightSidebar = true;
  @Input() handler: IPlatformToolHandler;
  @Input() isDraftFilter = false;
  @Input() filterSettings: ActivityFilterSettings = JSON.parse(JSON.stringify(DefaultActivityFilterSettings));
  @Input() conversationId = '';
  @Input() messageId = '';
  @Input() feedContentId: string = Guid.create().toString();
  @Input() changeNotificationSettingsEvent$: BehaviorSubject<ReferenceNotificationSettings> = new BehaviorSubject(null);
  @Output() newFeedInfo$: EventEmitter<any> = new EventEmitter();
  @Output() feedIdToRemove$: EventEmitter<any> = new EventEmitter();
  @Output() dataToHeader$: EventEmitter<any> = new EventEmitter();
  @Output() activityFeedInfoEvent$: EventEmitter<any> = new EventEmitter<any>();
  @Output() expandedInfoEvent$: EventEmitter<any> = new EventEmitter<any>();
  header$: BehaviorSubject<any> = new BehaviorSubject(null);
  saveFilter$: BehaviorSubject<string> = new BehaviorSubject(null);
  activityFeedTypes = ActivityFeedType;
  headerFilter$: BehaviorSubject<string> = new BehaviorSubject(null);
  focusEditorOnChatEditor$: BehaviorSubject<boolean> = new BehaviorSubject(true);
  allContacts$: any;
  allContacts: Array<any> = [];
  hashTagList: Array<string> = [];
  showFilterEditWindow = false;
  commentEditorId: string = Guid.create().toString();
  public unsubscribe$ = new Subject<void>();
  conversationsByFilter: ConversationsByFilter = null;
  title = '';
  showAllContacts = false;
  mention$: BehaviorSubject<Contact> = new BehaviorSubject<Contact>(null);
  // data for right sidebar
  @Input() public data: any = {};
  invalidatedRightSideComponentData$: BehaviorSubject<any> = new BehaviorSubject(null);
  //
  currentMenuItem: any = null;
  userInfo$: any;
  userInfo: UserInfo;
  platformLink: MagicLinkModel = null;
  isDirtyActivities = false;
  canInvalidateActivityFeedInfo = true;
  realTimeUpdateInfo: ActivityDataRealTimeUpdateInfo = new ActivityDataRealTimeUpdateInfo();
  private fetchActivityTimeout: NodeJS.Timer;
  addCommentQueueList: Array<string> = [];
  flatMenus: any[] = [];
  draftCommentText = '';
  activityFilter: ActivityFilterModel = null;
  errorOccured = false;
  allSolutionToolsQueryKey = 'GetContactSolutionTreesAllTools';
  private allTools$: any;
  allSolutionTools: ToolInfo[] = [];
  hasDefaultPublication = false;
  hasFeature$: Observable<any>;
  isMagicLinkOnly: boolean;
  hideCustomActivity: boolean;
  private fetchActivitiesSubscriber = new Subject<void>();
  isContactsVisible: boolean;
  private involvedUserEmails: any[] = [];
  involvedUsers: Contact[] = [];
  currentUser: UserModel;
  countries: CountryModel[];
  ngUnsubscribe = new Subject<void>();
  contactsList: Contact[] = [];
  private lastSeen$: Observable<any>;
  showOnlineContacts = true;
  private lastSeenDictionary: any;
  @ViewChild('panel') panel: MatExpansionPanel;
  constructor(private contactStore: Store<ContactState>,
              private securityStore: Store<SecurityState>,
              private activityFilterService: ActivityFilterService,
              private navigationStore: Store<NavigationState>,
              private dialogService: DialogService,
              private queryStore: Store<IQueryState>,
              private timeZoneService: TimeZoneService,
              private platformSidebarStore: Store<PlatformSidebarState>,
              private changeDetector: ChangeDetectorRef,
              private particleStore: Store<ParticleState>,
              private graphQLService: GraphQLService,
              private platformSidebarService: PlatformSidebarService,
              private snackBarService: SnackBarService,
              private collaborationStore: Store<CollaborationState>,
              private platformQueryService: PlatformQueryService,
              private commandService: CommandService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private flexSheetService: FlexSheetService,
              private router: Router) {
    this.securityStore.select(getUserInfo).pipe(takeUntil(this.ngUnsubscribe)).subscribe(currentUser => {
      if (currentUser) {
        this.currentUser = currentUser;
      }
    });

  }

  ngOnInit() {
    this.allContacts$ = this.contactStore.select(getAllContacts).pipe(takeUntil(this.unsubscribe$));
    this.allContacts$.subscribe(data => {
      if (data) {
        this.allContacts = data.raw;
      }
    });
    this.particleStore.pipe(select(getAllCountries), takeUntil(this.unsubscribe$))
      .subscribe((countries: any) => {
        this.countries = countries;
      });
    console.log('initiating activity feed:', this.data);
    if (this.data && this.data.type) { // action dispatched data
      this.feedInfo = JSON.parse(JSON.stringify(this.data));
      if (this.isExpanded) {
        this.viewActivity();
      }
      this.canInvalidateActivityFeedInfo = false; // we need to skip platform link feed execution
    }
    if (this.feedInfo && this.feedInfo.type) {
      this.synChronizeFilterSetting(this.feedInfo.type, this.feedInfo.auditTrail, this.feedInfo.dateRangeType, this.feedInfo.startDate, this.feedInfo.endDate);
      this.setActivityFeedHeaderMenuType();
      this.dataToHeader$.emit(this.filterSettings);
      this.header$.next(this.filterSettings);
      this.invalidateFeedData(this.filterSettings);
    }
    this.showFilterEditWindow = this.isDraftFilter;
    this.userInfo$ = this.securityStore.select(getUserInfo);
    this.userInfo$.subscribe(userInfo => {
      this.userInfo = userInfo;
    });
    this.allTools$ = this.queryStore.pipe(select(getQueryResponse, this.allSolutionToolsQueryKey), takeUntil(this.unsubscribe$));
    this.allTools$.subscribe(allTools => {
      if (allTools && allTools.length > 0) {
        this.allSolutionTools = allTools;
        this.checkForDefaultPublication();
      }
    });
    QueryProvider.invokeQuery(this.queryStore, this.allSolutionToolsQueryKey, {});
    this.collaborationStore.select(getOthersTrackBatchActivity).pipe(takeUntil(this.unsubscribe$)).subscribe((othersTrackBatchActivity: any) => {
      // console.log('othersTrackBatchActivity:', othersTrackBatchActivity);
      this.handleRealTimeBatchActivityUpdates(othersTrackBatchActivity);
    });
    this.headerFilter$.pipe(takeUntil(this.unsubscribe$)).subscribe(headerFilter => {
      if (headerFilter) {
        this.onActivityHeaderFilterChange(headerFilter);
      }
    });

    this.particleStore.select(getCurrentPlatformLink).pipe(takeUntil(this.unsubscribe$)).subscribe((platformLink: any) => {
      this.platformLink = platformLink;
      this.setUserActionForStepByStep();
      console.log('activity feed platform link subscriber:', platformLink, this.setFeedOnRightSidebar, this.canInvalidateActivityFeedInfo);
      if (this.setFeedOnRightSidebar && this.canInvalidateActivityFeedInfo) {
        this.isDirtyActivities = true;
        this.startFetchTimeout();
      }
    });

    this.navigationStore.select(getCurrentMenuItem).pipe(takeUntil(this.unsubscribe$)).subscribe(item => {
      this.currentMenuItem = item;
      console.log('activity feed current menu item link subscriber:', item, this.setFeedOnRightSidebar, this.canInvalidateActivityFeedInfo);
      if (this.setFeedOnRightSidebar) {
        if (this.canInvalidateActivityFeedInfo) {
          this.isDirtyActivities = true;
          this.startFetchTimeout();
        } else {
          // lets works for filter
          this.invalidateFilterRelatedActivity();
        }
        // // this.platformSidebarStore.dispatch(new PopCurrentRightSideComponentAction('ActivityFeedComponent'));
      }
    });
    if (this.handler && this.handler.magicLinkModelValueChanged) {
      this.handler.magicLinkModelValueChanged.pipe(takeUntil(this.unsubscribe$)).subscribe(commamd => {
        this.handleMagicLinkValueChanged(commamd);
      });
    }

    this.collaborationStore.select(getcurrentEditorId).pipe(takeUntil(this.unsubscribe$)).subscribe((currentEditorId: string) => {
      this.onEditorIdChange(currentEditorId);
    });

    this.contactStore.dispatch(new GetAllSharedContactsAction());
    this.invalidatedRightSideComponentData$.pipe(takeUntil(this.unsubscribe$)).subscribe(data => {
      console.log('activity feed data invalidate data:', data);
      if (data && data.type && (this.canInvalidateActivityFeedInfo || data.type.toLowerCase() === ActivityFeedType.DateRange.toLowerCase())) {
        this.canInvalidateActivityFeedInfo = true;
        this.platformSidebarService.unlockSidebar();
        this.showFilterEditWindow = false;
        this.feedInfo = data;
        this.synChronizeFilterSetting(this.feedInfo.type, this.feedInfo.auditTrail, this.feedInfo.dateRangeType, this.feedInfo.startDate, this.feedInfo.endDate);
        this.setActivityFeedHeaderMenuType();
        this.dispatchFilterSettings();
      }
    });
    this.canInvalidateActivityFeedInfo = true;
    this.isContactsVisible = true;
    this.hasFeature$ = this.securityStore.pipe(select(hasFeature), takeUntil(this.unsubscribe$));
    this.hasFeature$.subscribe(feature => {
      if (feature) {
        this.isMagicLinkOnly = feature('MAGIC-LINK-ONLY') === true;
        this.hideCustomActivity = feature('HIDE-CUSTOM-ACTIVITY') === true;
      }
    });
    this.changeNotificationSettingsEvent$.pipe(skip(1), takeUntil(this.ngUnsubscribe)).subscribe(value => {
      if (value) {
        this.changeNotificationSettingsEvent(value);
      }
    });
  }
  ngAfterViewInit(): void {
    this.fixScrollToView();
  }

  fixScrollToView() {
    if (this.showChatEditor || this.data?.showChatEditor) {
      setTimeout(() => {
        this.scrollToBottom();
      }, 500);
    } else if (this.isExpanded) {
      setTimeout(() => {
        this.scrollToTop();
      }, 1000);
    }
  }
  onMenuClick() {
    this.panel.close();
  }
  onOpen() {
    this.expandedInfoEvent$.emit({
      type: 'open',
      feedId: this.feedInfo?.id
    });
  }
  onClose() {
  }
  private startFetchTimeout() {
    if (this.fetchActivityTimeout) {
      clearTimeout(this.fetchActivityTimeout as NodeJS.Timeout);
    }
    const self = this;
    this.fetchActivityTimeout = setTimeout(() => {
      if (self.isDirtyActivities) {
        self.isDirtyActivities = false;
        self.getToolIdFromRoute();
      }
    }, 2000);
  }

  private handleMagicLinkValueChanged(action: any) {
    // console.log('on activity feed:', action);
    if (action) {
      switch (action.name) {
        case 'AuditTrailCommand':
          this.onAuditTrailChange({checked: action.command.isChecked});
          break;
        case 'SaveActivityFilterCommand':
          this.saveFilter(action.command);
          break;
        case 'DateFilterCommand':
          this.onDateRangeChangeFromToolbar(action.command);
          break;
        case 'FilterSettingChanges':
          this.invalidateFeedData(action.filterSettings);
          break;
        case 'ExportActivityCommand':
          // this.onExportActivityFeed(this.feedContentId);
          break;
      }
    }
  }

  onDefaultPublicationClicked() {
    this.feedInfo = new ActivityFeedInfo({
      type: ActivityFeedType.Tool,
      id: this.feedInfo.id,
      isDefault: false,
      title: this.feedInfo.title,
      auditTrail: this.filterSettings.auditTrail,
      isUserAction: true
    });
    this.miningAndUpdateFeedInfo(this.feedInfo);
  }
  saveFilter(command: PlatformCommand = null) {
    if (!this.feedInfo || (!this.feedInfo.isDefault && !this.setFeedOnRightSidebar)) {
      return;
    }
    if (this.feedInfo.type && this.feedInfo.type.toLowerCase() === ActivityFeedType.Filter.toLowerCase() && this.feedInfo.id) {
      this.activityFilterService.ChangeFilterTilteDialog('Custom Filter').pipe(takeUntil(this.unsubscribe$)).subscribe((title: any) => {
        if (title) {
          if (this.showFilterEditWindow) {
            this.saveFilter$.next(title);
          } else {
            this.copyAsNewSavedFilter(this.feedInfo.id, title);
          }
        }
      });
    }
  }

  saveFilterToApi(fieldValues: any = {}) {
    this.activityFilterService.saveActivityFilter(fieldValues).pipe(takeUntil(this.unsubscribe$)).subscribe(filter => {
      if (filter) {
        this.invalidateFilter(filter);
      }
    });
  }

  dispatchDataToHandler(event) {
    if (!this.setFeedOnRightSidebar) {
      this.handler.valueChanged(event);
    }
  }

  onAddNewFilter($event) {
    // set add filter context in memory
  }

  onAddNewFeed(feed: ActivityFeedInfo) {
    // console.log('on activity feed:', feed);
    this.newFeedInfo$.emit(feed);
    if (this.setFeedOnRightSidebar) {
      if (feed.type.toLowerCase() === ActivityFeedType.DateRange.toLowerCase()) {
        this.filterSettings.startDate = feed.startDate;
        this.filterSettings.endDate = feed.endDate;
        this.filterSettings.dateRangeType = feed.dateRangeType;
        this.filterSettings.activityFeedType = feed.type;
      }
      this.platformSidebarService.unlockSidebar();
      this.canInvalidateActivityFeedInfo = true;
      this.filterSettings.activityFeedType = feed.type;
      this.feedInfo = feed;

      this.feedInfo.isUserAction = true;
      this.addCommentQueueList = []; // clearing all commentId for previous feed
      this.setActivityFeedHeaderMenuType();
      this.dispatchFilterSettings();
    }
    // this action acutally used for test purpose. need to remove
    // this.platformSidebarStore.dispatch(new SetActivityFeedAction(DefaultActivityFeedByTool));
  }

  onSelectAddComment($event?: any) {
    this.panel.open();
    this.showChatEditor = true;
    this.collaborationStore.dispatch(new SetCurrentTextEditorId(this.commentEditorId));
    this.focusEditorOnChatEditor$.next(true);
    setTimeout(() => {
      this.scrollToBottom();
    }, 0);
  }
  scrollToBottom(): void {
    const element = document.getElementById('chatEditor-' + this.feedInfo?.id);
    if (element) {
      element.scrollIntoView(true);
    }
  }
  scrollToTop(): void {
    const element = document.getElementById(this.feedInfo?.id);
    if (element) {
      element.scrollIntoView(true);
    }
  }

  onAddComment(chatEditorOutput: ChatEditorOutput) {
    this.draftCommentText = '';
    this.showChatEditor = false;
    if (this.data?.showChatEditor === true) {
      this.data.showChatEditor = false;
    }
    const commentText = chatEditorOutput.chatText;
    const attachment = chatEditorOutput.attachment;
    if (commentText.trim().length === 0 && attachment.trim().length === 0) {
      return;
    }
    const messageCommands = {};
    let item: string;
    let itemKey: string;
    let itemId: string;
    if (this.feedInfo.type.toLowerCase() === ActivityFeedType.ItemsKey.toLowerCase()) {
      item = this.feedInfo.id;
      const reg = /\[([^\]]+)]\[([^\]]+)]/;
      const itemInfo = item.match(reg);
      if (itemInfo && itemInfo.length === 3) {
        itemKey = itemInfo[1];
        itemId = itemInfo[2];
      }
    } else if (this.feedInfo.type.toLowerCase() === ActivityFeedType.Filter.toLowerCase()) {
      itemKey = ActivityFeedType.Filter;
      itemId = this.feedInfo.id;
      item = `[${itemKey}][${itemId}]`;
    } else if (this.feedInfo.type.toLowerCase() === ActivityFeedType.Tool.toLowerCase()) {
      itemKey = ActivityFeedType.Tool;
      itemId = this.feedInfo.id;
      item = `[${itemKey}][${itemId}]`;
    } else if (this.feedInfo.type.toLowerCase() === ActivityFeedType.ReferenceCode.toLowerCase()) {
      itemKey = ActivityFeedType.ReferenceCode;
      itemId = this.feedInfo.id;
      item = `[${itemKey}][${itemId}]`;
    } else if (this.feedInfo.type.toLowerCase() === ActivityFeedType.DateRange.toLowerCase()) {
      itemKey = ActivityFeedType.DateRange;
      item = '';
    } else if (this.feedInfo.type.toLowerCase() === ActivityFeedType.DataContextFeed.toLowerCase()) {
      itemKey = ActivityFeedType.DataContextFeed;
      itemId = this.feedInfo.id;
      item = `[${itemKey}][${itemId}]`;
    } else {
      this.snackBarService.showError('Comment cannot be added.');
      return;
    }

    let conversationTitle = this.feedInfo.title;
    if (this.feedInfo.type.toLowerCase() === ActivityFeedType.DateRange.toLowerCase()) {
      const moment = moment_;
      conversationTitle = moment(new Date()).format('DD MMM YYYY');
    }
    const prefixComment = `<a id="[User][${this.userInfo.email}]" class="activity-link-user">${this.userInfo.firstName ? this.userInfo.firstName : ''} ${this.userInfo.lastName ? this.userInfo.lastName : ''}</a> added a comment for <a id="${item}" class="activity-link-${itemKey.toLowerCase()}">${conversationTitle}</a>.`;
    const command = new PlatformCommand('AddCommentAsActivityCommand', 'CollaborationApi');
    command.fieldValues['ItemKey'] = itemKey;
    command.fieldValues['ItemId'] = itemId;
    command.fieldValues['DisplayText'] = conversationTitle;
    command.fieldValues['PrefixComment'] = prefixComment;
    command.fieldValues['Attachment'] = commentText;
    command.fieldValues['CollaborationRoles'] = chatEditorOutput.selectedContacts;
    command.fieldValues['Title'] = conversationTitle;
    command.fieldValues['ConversationId'] = Guid.create().toString();
    command.fieldValues['ActivityFeedType'] = this.feedInfo.type;
    if (this.feedInfo.additionReferenceCodes) {
      command.fieldValues['AdditionalReferenceCodes'] = this.feedInfo.additionReferenceCodes;
    }
    command.scope = ContentScope.Company; // comment will always be company specific
    command.impersonationId = this.getImpersonationId(this.feedInfo.isUseImpersonation, this.feedInfo.impersonationId);
    this.beforeAddCommentExecutionActions(command, item, itemKey);
    this.addCommentQueueList.push(command.fieldValues['ConversationId']);
    command.waitForResponse = true;
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
        if (commandResponse && commandResponse.fieldValues['Conversation']) {
          const conversation = commandResponse.fieldValues['Conversation'];
          if (this.addCommentQueueList && this.addCommentQueueList.length > 0) {
            if (this.addCommentQueueList.indexOf(conversation.id) !== -1) {
              this.placeNewConversation(conversation);
              setTimeout(() => {
                this.changeDetector.detectChanges();
              }, 500);
            }
          }
        }
      },
      error => {
        console.error('Add comment failed!', error);
        this.snackBarService.showError('Add comment failed!');
      });
  }

  // ITP-E-409-03: the feed is newest first (ITP-E-409-01), so a comment you just added goes to the top of the page,
  // right under a pinned deep-linked entry when there is one (ITP-W-007).
  placeNewConversation(conversation: Conversation) {
    const conversations = this.conversationsByFilter.conversations;
    const pinned = this.conversationsByFilter.conversation && conversations[0]?.id === this.conversationId;
    conversations.splice(pinned ? 1 : 0, 0, conversation);
    if (this.conversationsByFilter?.recordCount > 0) {
      this.conversationsByFilter.recordCount++;
    }
  }

  onCancelChatEditor($event) {
    if ($event) {
      this.showChatEditor = false;
      if (this.data?.showChatEditor === true) {
        this.data.showChatEditor = false;
      }
      this.draftCommentText = '';
    }
  }

  onFilterSelect($event) {
    if (this.feedInfo.type.toLowerCase() !== ActivityFeedType.Filter.toLowerCase()) {
      this.feedInfo.type = ActivityFeedType.Filter;
      this.feedInfo.id = '';
      this.feedInfo.auditTrail = DefaultActivityFilterSettings.auditTrail;
      this.feedInfo.dateRangeType = DefaultActivityFilterSettings.dateRangeType;
      this.feedInfo.startDate = DefaultActivityFilterSettings.startDate;
      this.feedInfo.endDate = DefaultActivityFilterSettings.endDate;
      this.synChronizeFilterSetting(this.feedInfo.type, this.feedInfo.auditTrail, this.feedInfo.dateRangeType,
        this.feedInfo.startDate, this.feedInfo.endDate);
      this.setActivityFeedHeaderMenuType();
    }
    if (this.setFeedOnRightSidebar) {
      this.platformSidebarService.lockSidebar();
    }
    this.showFilterEditWindow = true;
    this.canInvalidateActivityFeedInfo = false;
  }

  onCancelFilter($event) {
    this.showFilterEditWindow = false;
    this.miningAndUpdateFeedInfo(this.feedInfo);
  }

  ngOnDestroy() {
    // console.log('calling destructor on feed:', this.feedInfo);
    if (this.fetchActivityTimeout) {
      clearTimeout(this.fetchActivityTimeout as NodeJS.Timeout);
    }
    // this.platformSidebarStore.dispatch(new SetActivityFeedAction(null));
    this.clearFetchActivitiesSubscriber();
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  closeActivityFeed($event) {
    // console.log('close id:', $event);
    if (this.setFeedOnRightSidebar) {
      // this.getToolIdFromRoute();
      this.isDirtyActivities = true;
      this.platformSidebarService.unlockSidebar();
      this.canInvalidateActivityFeedInfo = true;
      this.showOnlineContacts = true;
      this.setContactsList();
      this.startFetchTimeout();
      return;
    }
    this.feedIdToRemove$.emit(this.feedInfo);
  }

  onExportActivityFeed(feedContentId, exportType) {
    this.feedInfo.auditTrail = this.filterSettings.auditTrail;
    this.feedInfo.dateRangeType = this.filterSettings.dateRangeType;
    this.feedInfo.startDate = this.getStartDate(this.filterSettings.startDate);
    this.feedInfo.endDate = this.getEndDate(this.filterSettings.endDate);
    this.feedInfo.relatedToolIdForFilter = this.getCurrentTool();
    this.activityFilterService.exportActivityFeeds([this.feedInfo], exportType, this.feedInfo.impersonationId);
  }

  private getToolIdFromRoute() {
    if (this.platformLink && this.platformLink.activityFeedInfo) {
      this.showFilterEditWindow = false;
      const feedInfo = JSON.parse(JSON.stringify(this.platformLink.activityFeedInfo)); // so that it does not change main object
      this.setUserActionForStepByStep();
      if (this.isFeedInfoSame(feedInfo)) {
        return;
      }
      this.feedInfo = feedInfo;
      this.setUserActionForStepByStep();
    } else {
      this.showFilterEditWindow = false;
      this.extractFeedInfoFromRoute();
    }
    // console.log('feedInfo from tool route: ', this.feedInfo);
    if (this.feedInfo) {
      this.synChronizeFilterSetting(this.feedInfo.type, this.feedInfo.auditTrail, this.feedInfo.dateRangeType, this.feedInfo.startDate, this.feedInfo.endDate);
    }
    this.filterSettings.activityFeedType = this.feedInfo.type;
    this.setActivityFeedHeaderMenuType();
    this.dataToHeader$.emit(this.filterSettings);
    this.header$.next(this.filterSettings);
    this.addCommentQueueList = [];
    this.miningAndUpdateFeedInfo(this.feedInfo);
  }

  isFeedInfoSame(feedInfo: any) {
    if (!this.feedInfo || this.feedInfo.id !== feedInfo.id ||
      this.feedInfo.type !== feedInfo.type || this.feedInfo.title !== feedInfo.title ||
      this.feedInfo.isDefault !== feedInfo.isDefault || this.feedInfo.auditTrail !== feedInfo.auditTrail ||
      this.feedInfo.relatedToolIdForFilter !== feedInfo.relatedToolIdForFilter) {
      return false;
    }
    return true;
  }

  onAuditTrailChange($event: any) {
    if (!this.feedInfo) {
      return;
    }
    if (this.feedInfo.type.toLowerCase() === ActivityFeedType.Filter.toLowerCase() && this.feedInfo.id) {
      const fieldValues = {};
      fieldValues['AuditTrail'] = $event.checked;
      fieldValues['FilterId'] = this.feedInfo.id;
      this.saveFilterToApi(fieldValues);
    } else if (this.feedInfo.type) {
      this.filterSettings.auditTrail = $event.checked;
      console.log('audit trail change:', $event, this.filterSettings);
      this.dispatchFilterSettings();
    }
  }

  invalidateFilter(filter: any) {
    // console.log('invalidate filter:', filter);
    this.activityFilter = filter;
    this.showFilterEditWindow = false;
    this.isDirtyActivities = true;
    this.saveFilter$.next(null); // no filter to save
    this.synChronizeFilterSetting(ActivityFeedType.Filter, filter.dataFilter.auditTrail, ActivityDateRangeTypeScope.getDateRangeTypeId(filter.dateRangeFilter.dateRangeType), filter.dateRangeFilter.startDate, filter.dateRangeFilter.endDate);
    if (this.setFeedOnRightSidebar) {
      this.dataToHeader$.emit(this.filterSettings);
      this.header$.next(this.filterSettings);
      const feedInfo = new ActivityFeedInfo({
        type: ActivityFeedType.Filter,
        id: filter.id,
        isDefault: false,
        title: filter.title,
        auditTrail: filter.dataFilter.auditTrail
      });
      this.invalidateFeedData(this.filterSettings, feedInfo);
    } else {
      const invalidateInfo = {
        action: {id: 'InvalidateActivityTrackerView'},
        item: {type: ActivityFeedType.Filter, id: filter.id},
        filterSettings: this.filterSettings
      };
      if (filter.id !== this.feedInfo.id) {
        invalidateInfo.action.id = 'InvalidateActivityTrackerViewRoute';
      }
      this.dispatchDataToHandler(invalidateInfo);
    }
  }

  refreshFeedInfo(feedInfo: ActivityFeedInfo) {
    this.fuseSplashScreenService.show();
    this.miningAndUpdateFeedInfo(feedInfo);
    this.fuseSplashScreenService.hide();
    setTimeout(() => {
      this.scrollToTop();
    }, 500);
  }

  miningAndUpdateFeedInfo(feedInfo: ActivityFeedInfo, pageNo: number = 0, pageSize: number = 10) {
     // console.log('mining:', feedInfo);
    this.feedInfo = JSON.parse(JSON.stringify(feedInfo));
    // we will not fetch any data for unless this involved any user action
    if (this.setFeedOnRightSidebar && !this.feedInfo.isUserAction) {
      this.conversationsByFilter = null;
      // nullify the conversation list
      return;
    }
    if (this.feedInfo && this.feedInfo.type && this.feedInfo.type.toLowerCase() === ActivityFeedType.Filter.toLowerCase())  {
      // this.snackBarService.showError('This feature is not available right now.');
      this.feedInfo.isUserAction = true;
      this.conversationsByFilter = null;
      this.errorOccured = true;
      return;
    }
    if (this.feedInfoHasValidImpersonation(this.feedInfo, pageNo, pageSize) === false) {
      return;
    }
    this.getActivityFeedSpecificContactList(this.feedInfo);
    if (!this.showFilterEditWindow && this.feedInfo && this.feedInfo.type) {
      switch (this.feedInfo.type.toLowerCase()) {
        case ActivityFeedType.Filter.toLowerCase():
          this.fetchActivitiesByFilterId(this.feedInfo.id, pageNo, pageSize);
          break;
        case ActivityFeedType.ItemsKey.toLowerCase():
          this.fetchActivitiesByItemsKeyId(this.feedInfo.id, pageNo, pageSize);
          break;
        case ActivityFeedType.Tool.toLowerCase():
          this.fetchActivitiesByToolId(this.feedInfo.id, pageNo, pageSize);
          break;
        case ActivityFeedType.ReferenceCode.toLowerCase():
          this.fetchActivitiesByReferenceCode(this.feedInfo.id, pageNo, pageSize);
          break;
        case ActivityFeedType.ReferencePath.toLowerCase():
          this.fetchActivitiesByReferencePath(this.feedInfo.id, pageNo, pageSize);
          break;
        case ActivityFeedType.DateRange.toLowerCase():
          this.fetchActivitiesByDateRange(pageNo, pageSize);
          break;
        case ActivityFeedType.DataContextFeed.toLowerCase():
          this.fetchActivitiesByReferenceCode(this.feedInfo.id, pageNo, pageSize);
          break;
      }
    }
    if ( this.feedInfo.id && this.feedInfo.type.toLowerCase() === ActivityFeedType.ReferenceCode.toLowerCase()) {
      this.getInvolvedUsersByReferenceCode(this.feedInfo.id);

    }
    console.log('after mining:', this.feedInfo);
  }

  private fetchActivitiesByFilterId(filterId: string, pageNo: number = 0, pageSize: number = 20) {
    const query = CollaborationQuery.getConversationByFilterId(filterId, this.getCurrentTool(), this.filterSettings.auditTrail, pageNo, pageSize, ActivityDateRangeTypeScope.getDateRangeTypeGraphQl(this.filterSettings.dateRangeType), this.getStartDate(this.filterSettings.startDate), this.getEndDate(this.filterSettings.endDate), pageNo == 0 ? this.conversationId : '', pageNo == 0 ? this.messageId : '');
    this.fetchActivities(query);
  }

  private fetchActivitiesByItemsKeyId(itemsKey: string, pageNo: number = 0, pageSize: number = 20) {
    const query = CollaborationQuery.getConversationByItemKeyId(itemsKey, this.filterSettings.auditTrail, pageNo, pageSize, ActivityDateRangeTypeScope.getDateRangeTypeGraphQl(this.filterSettings.dateRangeType), this.getStartDate(this.filterSettings.startDate), this.getEndDate(this.filterSettings.endDate), this.filterSettings.supportOnly);
    this.fetchActivities(query);
  }

  private fetchActivitiesByDateRange(pageNo: number = 0, pageSize: number = 20) {
    const query = CollaborationQuery.getConversationByDateRange(this.filterSettings.auditTrail, pageNo, pageSize, ActivityDateRangeTypeScope.getDateRangeTypeGraphQl(this.filterSettings.dateRangeType), this.getStartDate(this.filterSettings.startDate), this.getEndDate(this.filterSettings.endDate), this.filterSettings.supportOnly);
    this.fetchActivities(query);
  }

  private fetchActivitiesByToolId(toolId: string, pageNo: number = 0, pageSize: number = 20) {
    this.showFilterEditWindow = false;
    if (pageNo === 0) {
      // we need to check default publication for one time
      this.checkForDefaultPublication();
    }
    const query = CollaborationQuery.getConversationByToolId(toolId, this.filterSettings.auditTrail, pageNo, pageSize, ActivityDateRangeTypeScope.getDateRangeTypeGraphQl(this.filterSettings.dateRangeType), this.getStartDate(this.filterSettings.startDate), this.getEndDate(this.filterSettings.endDate), this.hasDefaultPublication && !this.feedInfo.isDefault, this.filterSettings.supportOnly);
    this.fetchActivities(query);
  }

  fetchActivitiesByReferenceCode(referenceCode: string, pageNo: number = 0, pageSize: number = 20) {
    this.showFilterEditWindow = false;
    if(this.feedInfo.conversationId) {
      this.conversationId = this.feedInfo.conversationId;
    }
    const query = CollaborationQuery.getConversationByRefereceCode(referenceCode, GraphqlContentScope.getScope(0), this.filterSettings.auditTrail, pageNo, pageSize, this.getImpersonationId(this.feedInfo.isUseImpersonation, this.feedInfo.impersonationId), ActivityDateRangeTypeScope.getDateRangeTypeGraphQl(this.filterSettings.dateRangeType), this.getStartDate(this.filterSettings.startDate), this.getEndDate(this.filterSettings.endDate), pageNo === 0 ? this.conversationId : '', pageNo === 0 ? this.messageId : '', this.filterSettings.supportOnly);
    this.fetchActivities(query);
  }

  fetchActivitiesByReferencePath(referencePath: string, pageNo: number = 0, pageSize: number = 20) {
    this.showFilterEditWindow = false;
    const query = CollaborationQuery.getConversationByReferencePath(referencePath, GraphqlContentScope.getScope(0), this.filterSettings.auditTrail, pageNo, pageSize, this.filterSettings.supportOnly);
    this.fetchActivities(query);
  }

  private fetchActivities(query: string) {
    if (this.showFilterEditWindow) {
      return;
    }
    this.isDirtyActivities = true;
    this.realTimeUpdateInfo = new ActivityDataRealTimeUpdateInfo();
    this.errorOccured = false;
    this.clearFetchActivitiesSubscriber();
    this.fetchActivitiesSubscriber = new Subject<void>();
    this.graphQLService.executePostRequest(CollaborationConfig.CollaborationApiKey, query).pipe(takeUntil(this.fetchActivitiesSubscriber)).subscribe(payload => {
      this.clearFetchActivitiesSubscriber();
      if (payload && payload.data) {
        if (payload.data.conversationsByFilter) {
          this.isDirtyActivities = false;
          this.conversationsByFilter = payload.data.conversationsByFilter;
          if (this.conversationsByFilter.title) {
            this.feedInfo.title = this.conversationsByFilter.title;
            if (this.feedInfo.type.toLowerCase() === ActivityFeedType.DateRange.toLowerCase()) {
              const moment = moment_;
              this.feedInfo.title = `${moment(this.filterSettings.startDate).format('DD MMM YYYY')} - ${moment(this.filterSettings.endDate).format('DD MMM YYYY')}`;
            }
          }
          if (this.conversationsByFilter.isDefaultFilter) {
            this.showFilterEditWindow = false;
          }
          this.conversationsByFilter.startIndex = this.conversationsByFilter.recordCount > 0 ? ((this.conversationsByFilter.pageNo) * this.conversationsByFilter.pageSize) + 1 : this.conversationsByFilter.recordCount;
          this.conversationsByFilter.endIndex = ((this.conversationsByFilter.pageNo) * this.conversationsByFilter.pageSize) + this.conversationsByFilter.conversations.length;
          if (this.conversationsByFilter.conversation && this.conversationsByFilter.conversation.id === this.conversationId) {
            this.conversationsByFilter.conversations = this.conversationsByFilter.conversations.filter(c => c.id !== this.conversationId);
            this.conversationsByFilter.conversations.unshift(this.conversationsByFilter.conversation);
          }
        } else {
          this.isDirtyActivities = false;
          this.conversationsByFilter = payload.data.conversationsByFilter;
          this.errorOccured = true;
        }
      }
    });
  }

  pagination(dir: string) {
    let pageNo = -1;
    switch (dir) {
      case 'back':
        pageNo = this.conversationsByFilter.pageNo - 1;
        if (pageNo < 0) {
          return;
        }
        break;
      case 'forward':
        pageNo = this.conversationsByFilter.pageNo + 1;
        if (pageNo >= this.conversationsByFilter.pageCount) {
          return;
        }
        break;
    }
    this.miningAndUpdateFeedInfo(this.feedInfo, pageNo, this.conversationsByFilter.pageSize);
    setTimeout(() => {
      this.scrollToTop();
    }, 500);
  }

  private onDateRangeChangeFromToolbar(command) {
    // console.log('date toolbar: ', command);
    // only default feed can perform this operation
    if (!this.feedInfo || !this.feedInfo.isDefault) {
      return;
    }
    const dateRangeType = command.fieldValues['DateRangeType'];
    const startDate = command.fieldValues['StartDate'];
    const endDate = command.fieldValues['EndDate'];
    if (command.fieldValues['FiscalYearEnd'] && command.fieldValues['FiscalYearEnd'] !== '0001-01-01 00:00:00Z') {
      this.activityFilterService.setCurrentFiscalYearDate(new Date(command.fieldValues['FiscalYearEnd']));
    }
    this.onDateRangeChange(dateRangeType, startDate, endDate);
  }

  private onDateRangeChangeFromHeader() {
    // only default feed can perform this operation
    if (!this.feedInfo) {
      return;
    }
    const dateRangeType = this.filterSettings.dateRangeType;
    const startDate = this.filterSettings.startDate;
    const endDate = this.filterSettings.endDate;
    this.onDateRangeChange(dateRangeType, startDate, endDate);
  }

  private onDateRangeChange(dateRangeType: string, startDate: any, endDate: any) {
    const dialogModel: DialogModel = DialogModel.create(
      'Date Range',
      'DateRangeSelector',
      {dateRangeType: dateRangeType, startDate: startDate, endDate: endDate},
      '800px',
      '800px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      if (res.action === 'OK') {
        // console.log('date range selector: ', res.data.input);
        const data = res.data.input;
        if (this.feedInfo.type.toLowerCase() === ActivityFeedType.Filter.toLowerCase() && this.feedInfo.id) {
          const fieldValues = {};
          const dateRangeEnum = ActivityDateRangeTypeScope.getDateRangeEnum(data.dateRangeType);
          if (dateRangeEnum === -1) {
            this.snackBarService.showError('Please provide a valid date range type.');
          }
          fieldValues['DateRangeType'] = dateRangeEnum;
          fieldValues['StartDate'] = this.getStartDate(data.startDate);
          fieldValues['EndDate'] = this.getEndDate(data.endDate);
          fieldValues['FilterId'] = this.feedInfo.id;
          fieldValues['FiscalYearEnd'] = this.activityFilterService.fiscalYearEnd;
          this.saveFilterToApi(fieldValues);
        } else if (this.feedInfo.type) {
          this.filterSettings.dateRangeType = data.dateRangeType;
          this.filterSettings.startDate = data.startDate;
          this.filterSettings.endDate = data.endDate;
          this.filterSettings.fiscalYearEnd = this.activityFilterService.fiscalYearEnd;
          this.dispatchFilterSettings();
        }
      }
    });
  }

  private dispatchFilterSettings() { // need to make a single purpose method
    this.dataToHeader$.emit(this.filterSettings);
    this.header$.next(this.filterSettings);
    if (this.setFeedOnRightSidebar) {
      this.invalidateFeedData(this.filterSettings);
    }
  }

  private invalidateFeedData(filterSettings: ActivityFilterSettings, feedInfo: ActivityFeedInfo = null) {
    this.filterSettings = filterSettings;
    this.miningAndUpdateFeedInfo(feedInfo ? feedInfo : this.feedInfo);
  }

  private copyAsNewSavedFilter(filterId, title) {
    this.activityFilterService.copyAsNewSavedFilter(filterId, title).pipe(takeUntil(this.unsubscribe$)).subscribe(filter => {
      // console.log('saved filter:', filter);
      if (filter) {
        this.invalidateFilter(filter);
      }
    });
  }

  private handleRealTimeActivityUpdates(conversation: Conversation) {
    if (conversation && conversation.id && this.conversationsByFilter && this.conversationsByFilter.conversations &&
      this.addCommentQueueList.findIndex(c => c === conversation.id) === -1) {
      if (this.isSameFeedType(this.feedInfo, ActivityFeedType.Tool) && conversation.activityData.toolId === this.feedInfo.id) {
        this.updateNewActivityCount(conversation);
      } else if (this.conversationsByFilter.contextId === conversation.parentId) {
        this.updateNewActivityCount(conversation);
      }
    }
  }

  onEditorValueChange($event) {
    this.draftCommentText = $event;
  }

  isSameFeedType(feedInfo: ActivityFeedInfo, feedType: string) {
    if (!feedInfo || !feedInfo.id || !feedInfo.type ||
      !feedType || feedInfo.type.toLowerCase() !== feedType.toLowerCase()) {
      return false;
    }
    return true;
  }

  private updateNewActivityCount(conversation: Conversation) {
    if (this.conversationsByFilter.conversations.findIndex(c => c.id === conversation.id) === -1) {
      this.realTimeUpdateInfo.hasNewActivity = true;
      this.realTimeUpdateInfo.newActivityCount++;
    }
  }

  /*  private handleRealTimeReplyMessageUpdates(newReply: ConversationMessage) {
   if(this.conversationsByFilter && this.conversationsByFilter.conversations && this.conversationsByFilter.conversations.findIndex(c => c.id === newReply.conversationId) !== -1) {
   this.realTimeUpdateInfo.hasNewReply = true;
   this.realTimeUpdateInfo.newReplyCount++;
   }
   }*/
  private synChronizeFilterSetting(feedType, auditTrail, dateRangeType, startDate, endDate) {
    if (auditTrail === true) {
      this.filterSettings.auditTrail = true;
    } else if (auditTrail === false) {
      this.filterSettings.auditTrail = false;
    }
    let getDate = this.activityFilterService.getQuater(0);
    if (dateRangeType) {
      switch (dateRangeType.toLowerCase()) {
        case ActivityFilterDateRangeTypes.Last30Days.toLowerCase():
          this.filterSettings.dateRangeType = ActivityFilterDateRangeTypes.Last30Days;
          this.filterSettings.startDate = new Date(new Date().setDate(new Date().getDate() - 29));
          this.filterSettings.endDate = new Date();
          break;
        case ActivityFilterDateRangeTypes.Last90Days.toLowerCase():
          this.filterSettings.dateRangeType = ActivityFilterDateRangeTypes.Last90Days;
          this.filterSettings.startDate = new Date(new Date().setDate(new Date().getDate() - 89));
          this.filterSettings.endDate = new Date();
          break;
        case ActivityFilterDateRangeTypes.Today.toLowerCase():
          this.filterSettings.dateRangeType = ActivityFilterDateRangeTypes.Today;
          this.filterSettings.startDate = new Date();
          this.filterSettings.endDate = new Date();
          break;
        case ActivityFilterDateRangeTypes.Last7Days.toLowerCase():
          this.filterSettings.dateRangeType = ActivityFilterDateRangeTypes.Last7Days;
          this.filterSettings.startDate = new Date(new Date().setDate(new Date().getDate() - 6));
          this.filterSettings.endDate = new Date();
          break;
        case ActivityFilterDateRangeTypes.Quarter1.toLowerCase():
          this.filterSettings.dateRangeType = ActivityFilterDateRangeTypes.Quarter1;
          getDate = this.activityFilterService.getQuater(3);
          this.filterSettings.startDate = getDate['BeginDate'];
          this.filterSettings.endDate = getDate['EndDate'];
          break;
        case ActivityFilterDateRangeTypes.Quarter2.toLowerCase():
          this.filterSettings.dateRangeType = ActivityFilterDateRangeTypes.Quarter2;
          getDate = this.activityFilterService.getQuater(2);
          this.filterSettings.startDate = getDate['BeginDate'];
          this.filterSettings.endDate = getDate['EndDate'];
          break;
        case ActivityFilterDateRangeTypes.Quarter3.toLowerCase():
          this.filterSettings.dateRangeType = ActivityFilterDateRangeTypes.Quarter3;
          getDate = this.activityFilterService.getQuater(1);
          this.filterSettings.startDate = getDate['BeginDate'];
          this.filterSettings.endDate = getDate['EndDate'];
          break;
        case ActivityFilterDateRangeTypes.Quarter4.toLowerCase():
          this.filterSettings.dateRangeType = ActivityFilterDateRangeTypes.Quarter4;
          getDate = this.activityFilterService.getQuater(0);
          this.filterSettings.startDate = getDate['BeginDate'];
          this.filterSettings.endDate = getDate['EndDate'];
          break;
        case ActivityFilterDateRangeTypes.Custom.toLowerCase():
          this.filterSettings.dateRangeType = ActivityFilterDateRangeTypes.Custom;
          this.filterSettings.startDate = startDate;
          this.filterSettings.endDate = endDate;
          break;
        default:
          this.snackBarService.showError('Date range type is not correct.');
          break;
      }

      if (this.filterSettings.startDate) {
        this.filterSettings.startDate = new Date(this.filterSettings.startDate);
      } else {
        this.snackBarService.showError('Start date not found.');
      }
      if (this.filterSettings.endDate) {
        this.filterSettings.endDate = new Date(this.filterSettings.endDate);
      } else {
        this.snackBarService.showError('End date not found.');
      }
    }
    this.filterSettings.activityFeedType = feedType;
  }

  private extractFeedInfoFromRoute() {
    if (this.currentMenuItem && this.currentMenuItem.key) {
      const auditTrail = auditTrailMappingByToolId[this.currentMenuItem.key] ? true : false;
      this.feedInfo = new ActivityFeedInfo({
        type: ActivityFeedType.Tool,
        id: this.currentMenuItem.key,
        isDefault: true,
        title: this.currentMenuItem.title,
        auditTrail: auditTrail
      });
    } else {
      this.feedInfo = JSON.parse(JSON.stringify(DefaultActivityFeedByTool));
    }
  }

  private onEditorIdChange(currentEditorId: string) {
    if (currentEditorId && this.commentEditorId !== currentEditorId) {
      this.showChatEditor = false;
    }
  }

  private handleRealTimeBatchActivityUpdates(othersTrackBatchActivity: any[]) {
    // console.log('[oothersTrackBatchActivity]', othersTrackBatchActivity);//list<list<string>>
    // check if this action happed by current feed.
    if (this.conversationsByFilter && this.conversationsByFilter.referenceCode && othersTrackBatchActivity && othersTrackBatchActivity.length > 0) {
      othersTrackBatchActivity.forEach(referenceCodes => {
        if (referenceCodes && referenceCodes.length > 0) {
          let actionByCurrentFeed = false;
          if (this.addCommentQueueList && this.addCommentQueueList.length > 0) {
            this.addCommentQueueList.forEach(conversationId => {
              if (referenceCodes.indexOf(conversationId) !== -1) {
                actionByCurrentFeed = true;
                return;
              }
            });
          }
          if (actionByCurrentFeed) {
            return;
          }
          if (referenceCodes.indexOf(this.conversationsByFilter.referenceCode) !== -1) {
            this.realTimeUpdateInfo.newActivityCount += 1;
            this.realTimeUpdateInfo.hasNewActivity = true;
          }
        }
      });
    }
  }

  private checkForDefaultPublication() {
    if (this.feedInfo && this.feedInfo.type.toLowerCase() === ActivityFeedType.Tool.toLowerCase() && this.allSolutionTools.length > 0) {
      const currentTool = this.allSolutionTools.find(tool => tool.id === this.feedInfo.id);
      // console.log('current tool:', currentTool);
      if (currentTool !== undefined) {
        if (currentTool.relevantSourceTypes.indexOf('Orbitax') !== -1) {
          this.hasDefaultPublication = true;
          return;
        }
      }
    }
    this.hasDefaultPublication = false;
  }

  private getStartDate(dateTime: any) {
    // console.log('start datetime:', dateTime, typeof  dateTime);
    const startDate = new Date(dateTime);
    const sDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 0, 0, 0);
    const moment = moment_;
    return moment.utc(sDate).toDate();
  }

  private getEndDate(dateTime: any) {
    // console.log('end datetime:', dateTime, typeof  dateTime);
    const endDate = new Date(dateTime);
    const eDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 23, 59, 59);
    const moment = moment_;
    return moment.utc(eDate).toDate();
  }

  private setActivityFeedHeaderMenuType() {
    // initially in a right sidebar, we want to see related tool filter ans we are always in a tool
    if (this.filterSettings.activityFeedType && this.filterSettings.activityFeedType.toLowerCase() === ActivityFeedType.Filter.toLowerCase()) {
      this.filterSettings.activityHeaderMenuType = this.setFeedOnRightSidebar ? ActivityTrackerHeaderMenuTypes.RelatedActivity : ActivityTrackerHeaderMenuTypes.AllActivity;
    } else {
      this.filterSettings.activityHeaderMenuType = ActivityTrackerHeaderMenuTypes.AllActivity;
    }
  }

  private getCurrentTool() {
    if (this.filterSettings.activityHeaderMenuType === ActivityTrackerHeaderMenuTypes.RelatedActivity) {
      if (this.currentMenuItem && this.currentMenuItem.key) {
        return this.currentMenuItem.key;
      }
    }
    return '';
  }

  private onActivityHeaderFilterChange(headerFilter: string) {
    switch (headerFilter) {
      case 'DateRange':
        this.onDateRangeChangeFromHeader();
        break;
      case ActivityTrackerHeaderMenuTypes.AllActivity:
      case ActivityTrackerHeaderMenuTypes.RelatedActivity:
        this.filterSettings.activityHeaderMenuType = headerFilter;
        this.miningAndUpdateFeedInfo(this.feedInfo);
        break;
    }
  }

  private clearFetchActivitiesSubscriber() {
    if (this.fetchActivitiesSubscriber) {
      this.fetchActivitiesSubscriber.next();
      this.fetchActivitiesSubscriber.complete();
    }
  }

  private invalidateFilterRelatedActivity() {
    if (this.isSameFeedType(this.feedInfo, ActivityFeedType.Filter) && this.filterSettings.activityHeaderMenuType === ActivityTrackerHeaderMenuTypes.RelatedActivity) {
      this.miningAndUpdateFeedInfo(this.feedInfo);
    }
  }

  private feedInfoHasValidImpersonation(feedInfo: ActivityFeedInfo, pageNo: number, pageSize: number) {
    if (feedInfo && feedInfo.isUseImpersonation) {
      if (feedInfo.type && feedInfo.type.toLowerCase() === ActivityFeedType.ReferenceCode.toLowerCase()) {
        if (!feedInfo.impersonationId) {
          this.getImpersonationIdForCurrentFeed(feedInfo, pageNo, pageSize);
          return false;
        } else {
          return true;
        }
      } else {
        feedInfo.isUseImpersonation = false;
        feedInfo.impersonationId = '';
        this.snackBarService.showError('Impersonation only apply for reference code.');
        return  false;
      }
    }
    if (feedInfo) {
      feedInfo.impersonationId = '';
    }
    return true;
  }

  private getImpersonationIdForCurrentFeed(feedInfo: ActivityFeedInfo, pageNo: number, pageSize: number) {
    const platformCommand = new PlatformCommand('CreateImpersonationCommand', 'CollaborationApi');
    platformCommand.fieldValues['ServiceId'] = feedInfo.id;
    platformCommand.fieldValues['Message'] = `Creating impersonation from activity feed for service id: ${feedInfo.id}`;
    this.commandService.executePlatformCommand(platformCommand).pipe(take(1)).subscribe(response => {
      if (response && response.fieldValues && response.fieldValues['ImpersonationId']) {
        feedInfo.impersonationId = response.fieldValues['ImpersonationId'];
        this.miningAndUpdateFeedInfo(feedInfo, pageNo, pageSize);
      } else {
        this.snackBarService.showError('Impersonation id not found!');
      }
    }, err => {
      this.snackBarService.showError('Impersonation id not found!');
    });
  }

  private getImpersonationId(isUseImpersonation: boolean, impersonationId: string) {
    if (isUseImpersonation) {
      return impersonationId;
    }
    return '';
  }

  private beforeAddCommentExecutionActions(command: PlatformCommand, item: string, itemKey: string) {
    switch (this.feedInfo.sourceKey) {
      case 'ExpertService':
        this.handleExpertServiceAddComment(command);
        break;
    }
    if (this.platformLink?.fieldValues?.ScenarioType && this.flexSheetService.getFlexSheet()) {
      this.handleDataTracingAddComment(command);
      this.modifyDataTracingPrefixComment(command, item, itemKey);
    }
  }
  private modifyDataTracingPrefixComment(command: PlatformCommand, item: string, itemKey: string) {
    let isStepByStepEnabled = false;
    if (this.platformLink?.fieldValues?.isStepByStepEnabled) {
      isStepByStepEnabled = true;
    }
    const selectedCell = this.flexSheetService.selection.cellModel;
    const row = selectedCell ? selectedCell.er + 1 : 0;
    const col = ExcelHelper.getColumnName(selectedCell ? selectedCell.ec : 0);
    const cellAddress = `${col}${row}`;
    const worksheetName = this.flexSheetService.getCurrentWorkSheet().name;
    const countryName = this.getScenarioCountryName();
    const isFlowExecution = this.platformLink?.fieldValues?.IsFlowExecution;
    const prefixComment = `<a id="[User][${this.userInfo.email}]" class="activity-link-user">${this.userInfo.firstName ? this.userInfo.firstName : ''} ${this.userInfo.lastName ? this.userInfo.lastName : ''}</a> added a comment for cell <b>${cellAddress}</b> in <b>${worksheetName}</b> worksheet (<b>${countryName}</b>) ${isStepByStepEnabled ? 'as part of' : 'for'} <a id="${item}" class="activity-link-${itemKey.toLowerCase()}">${isStepByStepEnabled ? 'Step:' : ''} ${command.fieldValues['Title']}</a>${isFlowExecution ? ' stage' : ''}.`;
    command.fieldValues['PrefixComment'] = prefixComment;
  }
  private getScenarioCountryName() {
    const countryCode = this.platformLink?.fieldValues?.CountryCode;
    if (countryCode) {
      const country = this.countries.find(c => c.code === countryCode);
      if (country) {
        return country.name;
      }
    }
    const currentPlatformBasket = BasketProvider.getCurrentPlatformBasket();
    if (currentPlatformBasket) {
      return currentPlatformBasket.title;
    }
    return '';
  }
  private handleDataTracingAddComment(command: PlatformCommand) {
    const dataItem = new ActivityDataItem();
    dataItem.code = this.feedInfo?.id;
    dataItem.type = 'DataTracing';

    dataItem.fieldValues['IsOpenCalculator'] = this.platformLink.fieldValues?.IsOpenCalculator;

    dataItem.fieldValues['ScenarioId'] = this.platformLink.fieldValues?.ScenarioId;
    dataItem.fieldValues['ScenarioType'] = this.platformLink.fieldValues?.ScenarioType;
    dataItem.fieldValues['CountryCode'] = this.platformLink.fieldValues?.CountryCode;

    dataItem.fieldValues['WorkbookSetId'] = this.flexSheetService.getCurrentWorkBookSetId();
    dataItem.fieldValues['WorkbookId'] = this.flexSheetService.getCurrentWorkBook().id;
    dataItem.fieldValues['WorksheetId'] = this.flexSheetService.getCurrentWorkSheet().id;

    dataItem.fieldValues['CellRowIndex'] = this.flexSheetService.selection.cellModel.er;
    dataItem.fieldValues['CellColumnIndex'] = this.flexSheetService.selection.cellModel.ec;

    dataItem.fieldValues['ActiveRouteUrl'] = this.router.url;

    command.fieldValues['ActivityDataItem'] = dataItem;
  }
  private handleExpertServiceAddComment(command: PlatformCommand) {
    const dataItem = new ActivityDataItem();
    dataItem.code = this.feedInfo.id;
    dataItem.type = this.feedInfo.sourceKey;
    dataItem.fieldValues['ServiceId'] = this.feedInfo.id;
    dataItem.fieldValues['Title'] = this.feedInfo.title;
    dataItem.fieldValues['WorkspaceId'] = '';

    command.fieldValues['ActivityDataItem'] = dataItem;
  }

  private getActivityFeedSpecificContactList(feedInfo: ActivityFeedInfo) {
    switch (this.feedInfo.sourceKey) {
      case 'ExpertService':
        this.fetchExpertServiceContactList(feedInfo);
        break;
    }
  }

  private fetchExpertServiceContactList(feedInfo: ActivityFeedInfo) {
    if (feedInfo.contactsList && feedInfo.contactsList.length > 0) {
      return;
    }
    const query = new PlatformQuery();
    query.name = 'ExpertServiceModelContactsQuery';
    query.api = 'MarketPlaceApi';
    query.fieldValues['ServiceId'] = feedInfo.id;
    query.impersonationId = this.getImpersonationId(feedInfo.isUseImpersonation, feedInfo.impersonationId);
    this.platformQueryService.executeQuery(query).pipe(take(1)).subscribe(response => {
      if (response && response.fieldValues && response.fieldValues['ExpertServiceContacts']) {
        feedInfo.contactsList = response.fieldValues['ExpertServiceContacts'];
      }
    });
  }

  onNotificationSettings($event: MouseEvent) {
    if (!this.feedInfo || !this.feedInfo.type || !this.feedInfo.id || this.feedInfo.type.toLowerCase() !== ActivityFeedType.ReferenceCode.toLowerCase()) {
      this.snackBarService.showError('Notifications does not apply in current activity feed.');
      return;
    }
    const query = new PlatformQuery();
    query.name = 'ReferenceNotificationSettingsQuery';
    query.api = 'CollaborationApi';
    query.fieldValues['ReferenceCode'] = this.feedInfo.id;
    query.fieldValues['Title'] = this.feedInfo.title;
    let defaultNotificationPreference = ReferenceNotificationPreferenceType.MyMentions;
    switch (this.feedInfo.sourceKey) {
      case 'ExpertService':
        defaultNotificationPreference = ReferenceNotificationPreferenceType.NotifyAllMessages;
        break;
    }
    query.fieldValues['DefaultNotificationPreference'] = defaultNotificationPreference;
    query.impersonationId = this.getImpersonationId(this.feedInfo.isUseImpersonation, this.feedInfo.impersonationId);
    this.platformQueryService.executeQuery(query).pipe(take(1)).subscribe(response => {
      if (response && response.fieldValues && response.fieldValues['ReferenceNotificationSettingsModel']) {
        const referenceNotificationSettingsModel = response.fieldValues['ReferenceNotificationSettingsModel'];
        const dialogModel: DialogModel = DialogModel.create(
          this.feedInfo.title,
          'ReferenceNotificationSettingsComponent',
          {referenceNotificationSettings: referenceNotificationSettingsModel},
          '800px',
          '800px'
        );
        this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
          if (res.action === 'OK') {
             console.log('notification settings: ', res.data.input);
            const data = res.data.input;
            const notificationSettings = data.referenceNotificationSettings;
            notificationSettings.referenceCode = this.feedInfo.id;
            notificationSettings.title = this.feedInfo.title;
            const command = new PlatformCommand('SaveReferenceNotificationSettingsCommand', 'CollaborationApi');
            command.fieldValues['ReferenceNotificationSettingsModel'] = notificationSettings;
            command.isCamelCase = true;
            command.waitForResponse = true;
            command.impersonationId = this.getImpersonationId(this.feedInfo.isUseImpersonation, this.feedInfo.impersonationId);
            this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(payload => {
              console.log('response', payload);
              this.snackBarService.showInformation('Notification settings saved.');
            }, err => {
              this.snackBarService.showInformation('Some error occurred!');
            });
          }
        });
      } else {
        this.snackBarService.showError('Model fetching failed!');
      }
    }, err => {
      this.snackBarService.showError('Model fetching failed!');
    });
  }
  changeNotificationSettingsEvent(notificationSettings: ReferenceNotificationSettings) {
    notificationSettings.referenceCode = this.feedInfo.id;
    notificationSettings.title = this.feedInfo.title;
    const command = new PlatformCommand('SaveReferenceNotificationSettingsCommand', 'CollaborationApi');
    command.fieldValues['ReferenceNotificationSettingsModel'] = notificationSettings;
    command.isCamelCase = true;
    command.waitForResponse = true;
    command.impersonationId = this.getImpersonationId(this.feedInfo.isUseImpersonation, this.feedInfo.impersonationId);
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(payload => {
      console.log('response', payload);
      // this.snackBarService.showInformation('Notification settings saved.');
    }, err => {
      // this.snackBarService.showInformation('Some error occurred!');
    });
  }

  toggleContacts() {
    this.isContactsVisible = !this.isContactsVisible;
  }

  private getInvolvedUsersByReferenceCode(referenceCode: string) {
    if (referenceCode) {
      const query = new PlatformQuery();
      query.name = 'InvolvedUsersByReferenceCodeQuery';
      query.api = Api.Collaboration;
      query.fieldValues['ReferenceCode'] = referenceCode;
      this.feedInfo?.sourceKey === 'EATNode' ? query.fieldValues['NodeId'] = referenceCode : query.fieldValues['NodeId'] = '' ;
      this.platformQueryService.executeQuery(query).pipe(take(1)).subscribe(response => {
        if (response && response.fieldValues) {
          this.involvedUserEmails = response.fieldValues['Emails'];
          this.getContacts(referenceCode);
        }
      });
    }
  }

  private getContacts(referenceCode: string) {
    if (this.involvedUserEmails.length > 0) {
      const query = new PlatformQuery();
      query.name = 'GetContactsByEmailsQuery';
      query.api = Api.Contacts;
      query.fieldValues['Emails'] = this.involvedUserEmails;
      this.platformQueryService.executeQuery(query).pipe(take(1)).subscribe(response => {
        if (response && response.fieldValues) {
          this.involvedUsers = response.fieldValues['Contacts'];
          this.showAllContacts = false;
          this.showOnlineContacts = false;
          this.setContactsList();
        }
      });
    }
  }
handleInvolvedUserOnClick(involvedUser: any) {
    this.onSelectAddComment();
    setTimeout(() => {
      this.mention$.next(involvedUser);
      }, 10);
}
 openConversation(involvedUser: any) {
    const rolesArray = [];
    const otherUser = this.getOpenConversationOtherUser(involvedUser);
    rolesArray.push({'user': this.currentUser, permissionType: 290, 'roleTypes': [1, 2, 3]});
    rolesArray.push({'user': otherUser, permissionType: 290, 'roleTypes': [1, 2, 3]});
    const createChatConversationCommand = new CreateChatConversationCommand(
      '[COMPANY_ID]-chat',
      this.getOneToOneChatTitle(otherUser),
      false
      , 0,
      'Conversation',
      rolesArray,
      false,
      null,
      null
    );
    createChatConversationCommand.scope = ContentScope.Company;
    this.collaborationStore.dispatch(new CreateChatConversationAction(createChatConversationCommand, ConversationComponentName));
  }
  private getOpenConversationOtherUser(involvedUser: UserModel) {
    return {
       firstName: involvedUser.firstName,
       lastName: involvedUser.lastName,
       email: involvedUser.email
    };
  }
  getOneToOneChatTitle(otherUser) {
    if (otherUser) {
      return `${otherUser.firstName} ${otherUser.lastName}`;
    }
    return '';
  }

  switchContactsToLoad() {
    this.showAllContacts = !this.showAllContacts;
    if (this.feedInfo.type.toLowerCase() !== ActivityFeedType.ReferenceCode.toLowerCase()) {
      this.showOnlineContacts = !this.showOnlineContacts;
    }
    this.setContactsList();
  }

  private setContactsList() {
    if (this.showAllContacts) {
      this.contactsList = this.allContacts;
    } else if (this.showOnlineContacts) {
      this.contactsList = this.getOnlineContacts();
    } else {
      this.contactsList = this.involvedUsers;
    }
  }
  private getOnlineContacts(): Contact[] {
    const keys = Object.keys(this.lastSeenDictionary);
    // console.log('keys' + keys);
    return this.allContacts.filter(e => keys.includes(e.email));
  }

  activityHeaderFilterChange() {
    this.onActivityHeaderFilterChanged('DateRange');
  }

  onActivityHeaderFilterChanged($event) {
    this.headerFilter$.next($event);
  }

  viewActivity() {
    this.feedInfo.isUserAction = true;
    this.miningAndUpdateFeedInfo(this.feedInfo);
  }

  private setUserActionForStepByStep(){
    if(this.feedInfo && this.platformLink?.fieldValues?.isStepByStepEnabled) {
      this.viewActivity();
    }

  }
}
